import * as api from '../api/notice';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN/NOTICE';

export const FETCH_ALL_APPRAISAL_NOTICE_RUN = createRequestTypes(
  `${prefix}/FETCH_ALL_APPRAISAL_NOTICE_RUN`,
);
export const FETCH_ALL_APPRAISAL_NOTICE_CONFIG = createRequestTypes(
  `${prefix}/FETCH_ALL_APPRAISAL_NOTICE_CONFIG`,
);
export const VALIDATE_QUERY = createRequestTypes(`${prefix}/VALIDATE_QUERY`);
export const CREATE_APPRAISAL_NOTICE_RUN = createRequestTypes(
  `${prefix}/CREATE_APPRAISAL_NOTICE_RUN`,
);
export const DELETE_APPRAISAL_NOTICE_RUN = createRequestTypes(
  `${prefix}/DELETE_APPRAISAL_NOTICE_RUN`,
);
export const FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT = createRequestTypes(
  `${prefix}/FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT`,
);
export const FETCH_TAXING_UNITS_SUMMARY = createRequestTypes(
  `${prefix}/FETCH_TAXING_UNITS_SUMMARY`,
);
export const INSERT_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT = createRequestTypes(
  `${prefix}/INSERT_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT`,
);
export const DELETE_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT = createRequestTypes(
  `${prefix}/DELETE_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT`,
);
export const INSERT_APPRAISAL_NOTICE_CONFIG = createRequestTypes(
  `${prefix}/INSERT_APPRAISAL_NOTICE_CONFIG`,
);
export const FETCH_APPRAISAL_NOTICE_CONFIG = createRequestTypes(
  `${prefix}/FETCH_APPRAISAL_NOTICE_CONFIG`,
);
export const UPDATE_APPRAISAL_NOTICE_CONFIG = createRequestTypes(
  `${prefix}/UPDATE_APPRAISAL_NOTICE_CONFIG`,
);
export const DELETE_APPRAISAL_NOTICE_CONFIG = createRequestTypes(
  `${prefix}/DELETE_APPRAISAL_NOTICE_CONFIG`,
);
export const EXPORT_APPRAISAL_NOTICE_RUN = createRequestTypes(
  `${prefix}/EXPORT_APPRAISAL_NOTICE_RUN`,
);
export const EXPORT_FILE_DOWNLOAD_APPRAISAL_NOTICE_RUN = createRequestTypes(
  `${prefix}/EXPORT_FILE_DOWNLOAD_APPRAISAL_NOTICE_RUN`,
);
export const FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS = createRequestTypes(
  `${prefix}/FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS`,
);
export const FETCH_APPRAISAL_NOTICE_SUBMISSION = createRequestTypes(
  `${prefix}/FETCH_APPRAISAL_NOTICE_SUBMISSION`,
);
export const CREATE_APPRAISAL_NOTICE_SUBMISSION_RUN = createRequestTypes(
  `${prefix}/CREATE_APPRAISAL_NOTICE_SUBMISSION_RUN`,
);
export const FETCH_FOLDERS = createRequestTypes(`${prefix}/FETCH_FOLDERS`);
export const FETCH_IMPORTS = createRequestTypes(`${prefix}/FETCH_IMPORTS`);
export const IMPORT_NOTICE = createRequestTypes(`${prefix}/IMPORT_NOTICE`);
export const FETCH_EVENT_TYPES = createRequestTypes(
  `${prefix}/FETCH_EVENT_TYPES`,
);

export const FETCH_MASS_CREATE_COMP_GRIDS = createRequestTypes(
  `${prefix}/FETCH_MASS_CREATE_COMP_GRIDS`,
);

export const FETCH_MASS_CREATE_COMP_GRID = createRequestTypes(
  `${prefix}/FETCH_MASS_CREATE_COMP_GRID`,
);

export const CREATE_MASS_CREATE_COMP_GRID = createRequestTypes(
  `${prefix}/CREATE_MASS_CREATE_COMP_GRID`,
);

export const FETCH_NOTICE_DEFAULT_CONFIG = createRequestTypes(
  `${prefix}/FETCH_NOTICE_DEFAULT_CONFIG`,
);

export const FETCH_APPRAISAL_NOTICE_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_APPRAISAL_NOTICE_PROPERTIES`
);

export const FETCH_APPRAISAL_NOTICE_TAXING_UNITS = createRequestTypes('FETCH_APPRAISAL_NOTICE_TAXING_UNITS');
export const FETCH_APPRAISAL_NOTICE_EXEMPTIONS = createRequestTypes('FETCH_APPRAISAL_NOTICE_EXEMPTIONS');

export const fetchMassCreateCompGrids = makeApiActionCreatorV3(
  api.fetchMassCreateCompGrids,
  FETCH_MASS_CREATE_COMP_GRIDS[START],
  FETCH_MASS_CREATE_COMP_GRIDS[SUCCESS],
  FETCH_MASS_CREATE_COMP_GRIDS[ERROR],
);

export const fetchNoticeDefaultConfig = makeApiActionCreatorV3(
  api.fetchNoticeDefaultConfig,
  FETCH_NOTICE_DEFAULT_CONFIG[START],
  FETCH_NOTICE_DEFAULT_CONFIG[SUCCESS],
  FETCH_NOTICE_DEFAULT_CONFIG[ERROR],
);

export const fetchMassCreateCompGrid = makeApiActionCreatorV3(
  api.fetchMassCreateCompGrid,
  FETCH_MASS_CREATE_COMP_GRID[START],
  FETCH_MASS_CREATE_COMP_GRID[SUCCESS],
  FETCH_MASS_CREATE_COMP_GRID[ERROR],
);

export const createMassCreateCompGrids = makeApiActionCreatorV3(
  api.createMassCreateCompGrids,
  CREATE_MASS_CREATE_COMP_GRID[START],
  CREATE_MASS_CREATE_COMP_GRID[SUCCESS],
  CREATE_MASS_CREATE_COMP_GRID[ERROR],
);

export const fetchAllAppraisalNoticeRun = makeApiActionCreatorV3(
  api.fetchAllAppraisalNoticeRun,
  FETCH_ALL_APPRAISAL_NOTICE_RUN[START],
  FETCH_ALL_APPRAISAL_NOTICE_RUN[SUCCESS],
  FETCH_ALL_APPRAISAL_NOTICE_RUN[ERROR],
);

export const exportAppraisalNoticeRun = makeApiActionCreatorV3(
  api.exportAppraisalNoticeRun,
  EXPORT_APPRAISAL_NOTICE_RUN[START],
  EXPORT_APPRAISAL_NOTICE_RUN[SUCCESS],
  EXPORT_APPRAISAL_NOTICE_RUN[ERROR],
);

export const exportFileDownloadAppraisalNoticeRun = makeApiActionCreatorV3(
  api.exportFileDownloadAppraisalNoticeRun,
  EXPORT_FILE_DOWNLOAD_APPRAISAL_NOTICE_RUN[START],
  EXPORT_FILE_DOWNLOAD_APPRAISAL_NOTICE_RUN[SUCCESS],
  EXPORT_FILE_DOWNLOAD_APPRAISAL_NOTICE_RUN[ERROR],
);

export const fetchAllAppraisalNoticeConfig = makeApiActionCreatorV3(
  api.fetchAllAppraisalNoticeConfig,
  FETCH_ALL_APPRAISAL_NOTICE_CONFIG[START],
  FETCH_ALL_APPRAISAL_NOTICE_CONFIG[SUCCESS],
  FETCH_ALL_APPRAISAL_NOTICE_CONFIG[ERROR],
);

export const insertAppraisalNoticeConfig = makeApiActionCreatorV3(
  api.insertAppraisalNoticeConfig,
  INSERT_APPRAISAL_NOTICE_CONFIG[START],
  INSERT_APPRAISAL_NOTICE_CONFIG[SUCCESS],
  INSERT_APPRAISAL_NOTICE_CONFIG[ERROR],
);

export const fetchAppraisalNoticeConfig = makeApiActionCreatorV3(
  api.fetchAppraisalNoticeConfig,
  FETCH_APPRAISAL_NOTICE_CONFIG[START],
  FETCH_APPRAISAL_NOTICE_CONFIG[SUCCESS],
  FETCH_APPRAISAL_NOTICE_CONFIG[ERROR],
);

export const updateAppraisalNoticeConfig = makeApiActionCreatorV3(
  api.updateAppraisalNoticeConfig,
  UPDATE_APPRAISAL_NOTICE_CONFIG[START],
  UPDATE_APPRAISAL_NOTICE_CONFIG[SUCCESS],
  UPDATE_APPRAISAL_NOTICE_CONFIG[ERROR],
);

export const deleteAppraisalNoticeConfig = makeApiActionCreatorV3(
  api.deleteAppraisalNoticeConfig,
  DELETE_APPRAISAL_NOTICE_CONFIG[START],
  DELETE_APPRAISAL_NOTICE_CONFIG[SUCCESS],
  DELETE_APPRAISAL_NOTICE_CONFIG[ERROR],
);

export const validateQuery = makeApiActionCreatorV3(
  api.validateQuery,
  VALIDATE_QUERY[START],
  VALIDATE_QUERY[SUCCESS],
  VALIDATE_QUERY[ERROR],
);

export const createAppraisalNoticeRun = makeApiActionCreatorV3(
  api.createAppraisalNoticeRun,
  CREATE_APPRAISAL_NOTICE_RUN[START],
  CREATE_APPRAISAL_NOTICE_RUN[SUCCESS],
  CREATE_APPRAISAL_NOTICE_RUN[ERROR],
);

export const deleteAppraisalNoticeRun = makeApiActionCreatorV3(
  api.deleteAppraisalNoticeRun,
  DELETE_APPRAISAL_NOTICE_RUN[START],
  DELETE_APPRAISAL_NOTICE_RUN[SUCCESS],
  DELETE_APPRAISAL_NOTICE_RUN[ERROR],
);

export const fetchAllAppraisalNoticeConfigTaxingUnit = makeApiActionCreatorV3(
  api.fetchAllAppraisalNoticeConfigTaxingUnit,
  FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[START],
  FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[SUCCESS],
  FETCH_ALL_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[ERROR],
);

export const fetchTaxingUnitsSummary = makeApiActionCreatorV3(
  api.fetchTaxingUnitsSummary,
  FETCH_TAXING_UNITS_SUMMARY[START],
  FETCH_TAXING_UNITS_SUMMARY[SUCCESS],
  FETCH_TAXING_UNITS_SUMMARY[ERROR],
);

export const insertAppraisalNoticeConfigTaxingUnit = makeApiActionCreatorV3(
  api.insertAppraisalNoticeConfigTaxingUnit,
  INSERT_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[START],
  INSERT_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[SUCCESS],
  INSERT_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[ERROR],
);

export const deleteAppraisalNoticeConfigTaxingUnit = makeApiActionCreatorV3(
  api.deleteAppraisalNoticeConfigTaxingUnit,
  DELETE_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[START],
  DELETE_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[SUCCESS],
  DELETE_APPRAISAL_NOTICE_CONFIG_TAXING_UNIT[ERROR],
);

export const fetchAllAppraisalNoticeSubmissions = makeApiActionCreatorV3(
  api.fetchAllAppraisalNoticeSubmissions,
  FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS[START],
  FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS[SUCCESS],
  FETCH_ALL_APPRAISAL_NOTICE_SUBMISSIONS[ERROR],
);

export const fetchAppraisalNoticeSubmission = makeApiActionCreatorV3(
  api.fetchAppraisalNoticeSubmission,
  FETCH_APPRAISAL_NOTICE_SUBMISSION[START],
  FETCH_APPRAISAL_NOTICE_SUBMISSION[SUCCESS],
  FETCH_APPRAISAL_NOTICE_SUBMISSION[ERROR],
);

export const createAppraisalNoticeSubmissionRun = makeApiActionCreatorV3(
  api.createAppraisalNoticeSubmissionRun,
  CREATE_APPRAISAL_NOTICE_SUBMISSION_RUN[START],
  CREATE_APPRAISAL_NOTICE_SUBMISSION_RUN[SUCCESS],
  CREATE_APPRAISAL_NOTICE_SUBMISSION_RUN[ERROR],
);

export const fetchFolders = makeApiActionCreatorV3(
  api.fetchFolders,
  FETCH_FOLDERS[START],
  FETCH_FOLDERS[SUCCESS],
  FETCH_FOLDERS[ERROR],
);

export const fetchImports = makeApiActionCreatorV3(
  api.fetchImports,
  FETCH_IMPORTS[START],
  FETCH_IMPORTS[SUCCESS],
  FETCH_IMPORTS[ERROR],
);

export const importNotice = makeApiActionCreatorV3(
  api.importNotice,
  IMPORT_NOTICE[START],
  IMPORT_NOTICE[SUCCESS],
  IMPORT_NOTICE[ERROR],
);

export const fetchEventTypes = makeApiActionCreatorV3(
  api.fetchEventTypes,
  FETCH_EVENT_TYPES[START],
  FETCH_EVENT_TYPES[SUCCESS],
  FETCH_EVENT_TYPES[ERROR],
);

export const REMOVE_RUN_TAGS = createRequestTypes(`${prefix}/REMOVE_RUN_TAGS`);

export const removeRunTags = makeApiActionCreatorV3(
  api.removeRunTags,
  REMOVE_RUN_TAGS[START],
  REMOVE_RUN_TAGS[SUCCESS],
  REMOVE_RUN_TAGS[ERROR],
);
export const CREATE_PDF_EVENTS = createRequestTypes(
  `${prefix}/CREATE_PDF_EVENTS`,
);

export const createPdfEvents = makeApiActionCreatorV3(
  api.createPdfEvents,
  CREATE_PDF_EVENTS[START],
  CREATE_PDF_EVENTS[SUCCESS],
  CREATE_PDF_EVENTS[ERROR],
);

export const CAN_CREATE_EDR_NOTIFICATIONS = createRequestTypes(`${prefix}/CREATE_EDR_NOTIFICATIONS`);

export const canCreateEDRNotifications = makeApiActionCreatorV3(
  api.canCreateEDRNotifications,
  CAN_CREATE_EDR_NOTIFICATIONS[START],
  CAN_CREATE_EDR_NOTIFICATIONS[SUCCESS],
  CAN_CREATE_EDR_NOTIFICATIONS[ERROR],
);

export const CREATE_EDR_NOTIFICATIONS = createRequestTypes(`${prefix}/CREATE_EDR_NOTIFICATIONS`);

export const createEDRNotifications = makeApiActionCreatorV3(
  api.createEDRNotifications,
  CREATE_EDR_NOTIFICATIONS[START],
  CREATE_EDR_NOTIFICATIONS[SUCCESS],
  CREATE_EDR_NOTIFICATIONS[ERROR],
);

export const LOCK_PROPERTY = createRequestTypes(`${prefix}/LOCK_PROPERTY`);

export const lockProperty = makeApiActionCreatorV3(
  api.lockProperty,
  LOCK_PROPERTY[START],
  LOCK_PROPERTY[SUCCESS],
  LOCK_PROPERTY[ERROR],
);

export const CHECK_LIVE_RUN = createRequestTypes(`${prefix}/CHECK_LIVE_RUN`);

export const checkLiveRun = makeApiActionCreatorV3(
  api.checkLiveRun,
  CHECK_LIVE_RUN[START],
  CHECK_LIVE_RUN[SUCCESS],
  CHECK_LIVE_RUN[ERROR],
);

export const FETCH_IMPORT_MASS_FILES = createRequestTypes(`${prefix}/FETCH_IMPORT_MASS_FILES`);

export const fetchImportMassFiles = makeApiActionCreatorV3(
  api.fetchImportMassFiles,
  FETCH_IMPORT_MASS_FILES[START],
  FETCH_IMPORT_MASS_FILES[SUCCESS],
  FETCH_IMPORT_MASS_FILES[ERROR],
);

export const IMPORT_MASS_FILES = createRequestTypes(`${prefix}/IMPORT_MASS_FILES`);

export const importMassFiles = makeApiActionCreatorV3(
  api.importMassFiles,
  IMPORT_MASS_FILES[START],
  IMPORT_MASS_FILES[SUCCESS],
  IMPORT_MASS_FILES[ERROR],
);

export const GENERATE_PRE_SIGNED_URL = createRequestTypes(`${prefix}/GENERATE_PRE_SIGNED_URL`);

export const generatePreSignedURL = makeApiActionCreatorV3(
  api.generatePreSignedURL,
  GENERATE_PRE_SIGNED_URL[START],
  GENERATE_PRE_SIGNED_URL[SUCCESS],
  GENERATE_PRE_SIGNED_URL[ERROR],
);

export const FETCH_MASS_FILE_DETAILS = createRequestTypes(`${prefix}/FETCH_MASS_FILE_DETAILS`);

export const fetchMassFileDetails = makeApiActionCreatorV3(
  api.fetchMassFileDetails,
  FETCH_MASS_FILE_DETAILS[START],
  FETCH_MASS_FILE_DETAILS[SUCCESS],
  FETCH_MASS_FILE_DETAILS[ERROR],
);

export const fetchAppraisalNoticeProperties = makeApiActionCreatorV3(
  api.fetchAppraisalNoticeProperties,
  FETCH_APPRAISAL_NOTICE_PROPERTIES[START],
  FETCH_APPRAISAL_NOTICE_PROPERTIES[SUCCESS],
  FETCH_APPRAISAL_NOTICE_PROPERTIES[ERROR]
);

export const fetchAppraisalNoticeTaxingUnits = makeApiActionCreatorV3(
  api.fetchAppraisalNoticeTaxingUnits,
  FETCH_APPRAISAL_NOTICE_TAXING_UNITS[START],
  FETCH_APPRAISAL_NOTICE_TAXING_UNITS[SUCCESS],
  FETCH_APPRAISAL_NOTICE_TAXING_UNITS[ERROR]
);

export const fetchAppraisalNoticeExemptions = makeApiActionCreatorV3(
  api.fetchAppraisalNoticeExemptions,
  FETCH_APPRAISAL_NOTICE_EXEMPTIONS[START],
  FETCH_APPRAISAL_NOTICE_EXEMPTIONS[SUCCESS],
  FETCH_APPRAISAL_NOTICE_EXEMPTIONS[ERROR]
);

export const FETCH_PORTAL_NOTIFICATION_RUNS = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_RUNS`
);

export const FETCH_PENDING_PORTAL_NOTIFICATIONS = createRequestTypes(
  `${prefix}/FETCH_PENDING_PORTAL_NOTIFICATIONS`
);

export const CREATE_PORTAL_NOTIFICATION_RUN = createRequestTypes(
  `${prefix}/CREATE_PORTAL_NOTIFICATION_RUN`
);

export const fetchPortalNotificationRuns = makeApiActionCreatorV3(
  api.fetchPortalNotificationRuns,
  FETCH_PORTAL_NOTIFICATION_RUNS[START],
  FETCH_PORTAL_NOTIFICATION_RUNS[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_RUNS[ERROR]
);

export const fetchPendingPortalNotifications = makeApiActionCreatorV3(
  api.fetchPendingPortalNotifications,
  FETCH_PENDING_PORTAL_NOTIFICATIONS[START],
  FETCH_PENDING_PORTAL_NOTIFICATIONS[SUCCESS],
  FETCH_PENDING_PORTAL_NOTIFICATIONS[ERROR]
);

export const createPortalNotificationRun = makeApiActionCreatorV3(
  api.createPortalNotificationRun,
  CREATE_PORTAL_NOTIFICATION_RUN[START],
  CREATE_PORTAL_NOTIFICATION_RUN[SUCCESS],
  CREATE_PORTAL_NOTIFICATION_RUN[ERROR]
);

export const FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG`
);

export const UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG`
);

export const PREVIEW_PORTAL_NOTIFICATION_EMAIL = createRequestTypes(
  `${prefix}/PREVIEW_PORTAL_NOTIFICATION_EMAIL`
);

export const FETCH_PORTAL_NOTIFICATION_RECORDS = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_RECORDS`
);

export const fetchPortalNotificationEmailConfig = makeApiActionCreatorV3(
  api.fetchPortalNotificationEmailConfig,
  FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG[START],
  FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG[ERROR]
);

export const updatePortalNotificationEmailConfig = makeApiActionCreatorV3(
  api.updatePortalNotificationEmailConfig,
  UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG[START],
  UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG[SUCCESS],
  UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG[ERROR]
);

export const previewPortalNotificationEmail = makeApiActionCreatorV3(
  api.previewPortalNotificationEmail,
  PREVIEW_PORTAL_NOTIFICATION_EMAIL[START],
  PREVIEW_PORTAL_NOTIFICATION_EMAIL[SUCCESS],
  PREVIEW_PORTAL_NOTIFICATION_EMAIL[ERROR]
);

export const fetchPortalNotificationRecords = makeApiActionCreatorV3(
  api.fetchPortalNotificationRecords,
  FETCH_PORTAL_NOTIFICATION_RECORDS[START],
  FETCH_PORTAL_NOTIFICATION_RECORDS[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_RECORDS[ERROR]
);

export const FETCH_ELECTRONIC_DELIVERY_RECORDS_REQUEST = 'FETCH_ELECTRONIC_DELIVERY_RECORDS_REQUEST';
export const FETCH_ELECTRONIC_DELIVERY_RECORDS_SUCCESS = 'FETCH_ELECTRONIC_DELIVERY_RECORDS_SUCCESS';
export const FETCH_ELECTRONIC_DELIVERY_RECORDS_FAILURE = 'FETCH_ELECTRONIC_DELIVERY_RECORDS_FAILURE';

export const fetchElectronicDeliveryRecords = makeApiActionCreatorV3(
  api.fetchElectronicDeliveryRecords,
  FETCH_ELECTRONIC_DELIVERY_RECORDS_REQUEST,
  FETCH_ELECTRONIC_DELIVERY_RECORDS_SUCCESS,
  FETCH_ELECTRONIC_DELIVERY_RECORDS_FAILURE
);